module.exports = __webpack_public_path__ + "img/go.311baa3c.webp";